import { Constants } from '../defaults';
import { get, post, put, rdelete } from './methods';
//import querystring from 'query-string'
import qs from 'qs';

export const fetchIndicatorGenerator = (
  token,
  organization,
  project,
  filters = {},
) => {
  //const query = querystring.stringify(filters, { arrayFormat: 'bracket' })
  const query = qs.stringify(filters, { arrayFormat: 'brackets' });
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/IG?${query}`,
    {
      token,
    },
  ).then((r) => r);
};

export const getIndicatorGeneratorDetails = (
  token,
  organization,
  project,
  id,
) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/IG/${id}`,
    {
      token,
    },
  ).then((r) => r.indicator);
};

export const getUserVisits = (token) => {
  return get(`${Constants.API_URL}/v1/user-visits`, {
    token,
  }).then((r) => r);
};


export const getResourceReport = (token,start,end) => {
  return get(`${Constants.API_URL}/v1/resource-report?start=${start}&end=${end}`, {
    token,
  }).then((r) => r);
}

export const getUsersReport = (token,start,end) => {
  return get(`${Constants.API_URL}/v1/user-report?start=${start}&end=${end}`, {
    token,
  }).then((r) => r);
}

export const totalAnayatics = async (token) => {
  const r = await get(`${Constants.API_URL}/v1/overall-anaylatics`, {
    token,
  });
  return r;
}

export const confirmIndicatorGenerator = (
  token,
  organization,
  project,
  indicator,
  data,
) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/IG/${indicator}/action`,
    {
      token,
      data,
    },
  ).then((r) => r);
};

export const deleteProjectResource = (token, organization, project, id) => {
  return rdelete(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/RAL/resources/${id}`,
    {
      token,
    },
  ).then((r) => r.resource);
};

export const updateStudyCaseStatus = (token, code, status) => {
  return post(`${Constants.API_URL}/v1/me/studycases/${code}/status`, {
    token,
    data: {
      status,
    },
  }).then((r) => r.resource);
};

export const fetchIndicatorGeneratorFilters = (
  token,
  organization,
  project,
) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/IG/filters`,
    {
      token,
    },
  ).then((r) => r.filters);
};

export const login = (username, password) => {
  return post(`${Constants.API_URL}/v1/login`, {
    data: { username, password },
  }).then((r) => r.user);
};

export const validate = (code) =>
  get(`${Constants.API_URL}/v1/organizations/${code}`).then(
    (r) => r.organization,
  );

export const newUser = (code, user) =>
  post(`${Constants.API_URL}/v1/organizations/${code}/signup`, {
    data: user,
  }).then((r) => r.user);

export const newOrganization = (data) =>
  post(`${Constants.API_URL}/v1/signup/`, {
    data,
  }).then((r) => r.organization);

export const newProject = (token, organization, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects`,
    {
      token,
      data,
    },
  ).then((r) => r.project);
};

export const newStudyCase = (token, data) => {
  return post(`${Constants.API_URL}/v1/me/studycases`, {
    token,
    data,
  }).then((r) => r.studycase);
};

export const newGlossary = (token, data) => {
  return post(`${Constants.API_URL}/v1/glossary`, {
    token,
    data,
  }).then((r) => r.glossary);
};

export const getGlossasryItem = (token, id) => {
  return get(`${Constants.API_URL}/v1/glossary/${id}`, {
    token,
  }).then((r) => r.glossary);
};

export const updateGlossary = (token, data, id) => {
  return put(`${Constants.API_URL}/v1/glossary/${id}`, {
    token,
    data,
  }).then((r) => r.glossary);
};

export const fetchProjects = (token) => {
  return get(`${Constants.API_URL}/v1/me/projects`, {
    token,
  }).then((r) => r.data);
};

export const fetchDictionaries = (token) => {
  return get(`${Constants.API_URL}/v1/me/dictionaries`, {
    token,
  }).then((r) => r.dictionaries);
};

export const removeActivity = (token, organization, project, activity) => {
  return rdelete(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/ACTS/${activity}`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const removeGoal = (token, organization, project, data) => {
  return rdelete(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/GAO`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchDictionary = (token, id) => {
  return get(`${Constants.API_URL}/v1/me/dictionaries/${id}`, {
    token,
  }).then((r) => r.dictionary);
};

export const newDictionary = (token, data) => {
  return post(`${Constants.API_URL}/v1/me/dictionaries/`, {
    token,
    data,
  }).then((r) => r.dictionary);
};

export const editDictionary = (token, id, data) => {
  return put(`${Constants.API_URL}/v1/me/dictionaries/${id}`, {
    token,
    data,
  }).then((r) => r.dictionary);
};

export const deleteDictionary = (token, id) => {
  return rdelete(`${Constants.API_URL}/v1/me/dictionaries/${id}`, {
    token,
  }).then((r) => r.dictionary);
};

export const fetchORganizationsNames = (token) => {
  return get(`${Constants.API_URL}/v1/me/organizations/names`, {
    token,
  }).then((r) => r.organizations);
};

export const fetchOrganizations = (token) => {
  return get(`${Constants.API_URL}/v1/me/organizations`, {
    token,
  }).then((r) => r.organizations);
};

export const fetchOrganizationProjects = (token, organization) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects`,
    {
      token,
    },
  ).then((r) => r.projects);
};

export const fetchBasics = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/BSC`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putBasics = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/BSC/basics`,
    {
      token,
      data,
    },
  );
};

export const putStackholders = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/BSC/stackholders`,
    {
      token,
      data,
    },
  );
};

export const putRecipient = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/BSC/recipient`,
    {
      token,
      data,
    },
  );
};

export const putTarget = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/BSC/target`,
    {
      token,
      data,
    },
  );
};

export const createType = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/types`,
    {
      token,
      data,
    },
  ).then((r) => r.type);
};

export const createQuestion = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/questions`,
    {
      token,
      data,
    },
  ).then((r) => r.question);
};

export const createStackholder = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/stackholders`,
    {
      token,
      data,
    },
  ).then((r) => r.stackholder);
};

export const fetchEvaluatingResults = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/ERS`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const fetchEvaluateContext = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/evaluate-context`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putEvaluateContext = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/evaluate-context`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchPullAndPushFactors = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/pull-and-push-factors`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putPullAndPushFactors = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/pull-and-push-factors`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const updatePullFactors = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/pull-and-push-factors/pulls`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const updatePushFactors = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/pull-and-push-factors/pushes`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchRiskAndResilience = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/risk-and-resilience-factors`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putRiskAndResilience = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC/risk-and-resilience-factors`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const createRisk = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/risks`,
    {
      token,
      data,
    },
  ).then((r) => r.risk);
};

export const fetchToC = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putToC = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/TOC`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchGoals = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/GAO`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const postGoal = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/GAO`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const updateAllGoals = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/GAO`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchIndicators = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/IND`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putIndicators = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/IND`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchCollectionMethods = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/CMS`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putCollectionMethods = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/CMS`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchResourcesAndLimitations = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/RAL`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putResourcesAndLimitations = (
  token,
  organization,
  project,
  data,
) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/RAL`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const createResource = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/RAL/resources`,
    {
      token,
      data,
    },
  ).then((r) => r.resource);
};

export const fetchActivities = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/ACTS`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putActivities = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/ACTS`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const createActivity = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/ACTS/activities`,
    {
      token,
      data,
    },
  ).then((r) => r.activity);
};

export const fetchGoalsAndActivities = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/GAA`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putGoalsAndActivities = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/GAA`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchActualResults = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/AR`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const putActualResults = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/AR`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchProjectingResults = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/PRS`,
    {
      token,
    },
  ).then((r) => r.data);
};

export const fetchAllLinkedResources = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/library`,
    {
      token,
    },
  ).then((r) => r.links);
};

export const removeResourceFromProject = (token, key, data) => {
  return rdelete(`${Constants.API_URL}/v1/library/${key}/link`, {
    token,
    data,
  }).then((r) => r.link);
};

export const putProjectingResults = (token, organization, project, data) => {
  return put(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/sections/PRS`,
    {
      token,
      data,
    },
  ).then((r) => r.data);
};

export const fetchResources = (token, query) => {
  let search = '?type=resources';
  if (query) {
    search += '&' + query;
  }
  return get(`${Constants.API_URL}/v1/library${search}`, {
    token,
  }).then((r) => r.resources);
};

export const createMyResource = (token, data) => {
  return post(`${Constants.API_URL}/v1/library/resources`, {
    token,
    data,
  }).then((r) => r.resource);
};

export const fetchGlossary = (token) => {
  return get(`${Constants.API_URL}/v1/glossary`, {
    token,
  }).then((r) => r.items);
};

export const deleteGlossary = (token, id) => {
  return rdelete(`${Constants.API_URL}/v1/glossary/${id}`, {
    token,
  }).then((r) => r.glossary);
};

export const fetchReadingList = (token, query) => {
  let search = '';
  if (query) {
    search += '?&' + query;
  }
  return get(`${Constants.API_URL}/v1/me/reading-list${search}`, {
    token,
  }).then((r) => r.data);
};

export const createResourceLibrary = (token, data) => {
  return post(`${Constants.API_URL}/v1/library`, {
    token,
    data,
  }).then((r) => r.resource);
};

export const rateResource = (token, resource, data) => {
  return put(`${Constants.API_URL}/v1/library/${resource}/rate`, {
    token,
    data,
  }).then((r) => r.resource);
};

export const addReadList = (token, data) => {
  return post(`${Constants.API_URL}/v1/me/reading-list`, {
    token,
    data,
  }).then((r) => r.read);
};

export const acceptReadingList = (token, id) => {
  return put(`${Constants.API_URL}/v1/me/reading-list/${id}/accept`, {
    token,
  }).then((r) => r.read);
};

export const deleteUser = (token, id) => {
  return rdelete(`${Constants.API_URL}/v1/me/users/${id}`, {
    token,
  }).then((r) => r.user);
};

export const rejectReadingList = (token, id) => {
  return rdelete(`${Constants.API_URL}/v1/me/reading-list/${id}`, {
    token,
  }).then((r) => r.read);
};

export const getAllMembers = (token) => {
  return get(`${Constants.API_URL}/v1/me/members`, {
    token,
  }).then((r) => r.members);
};

export const shareResource = (token, id, data) => {
  return post(`${Constants.API_URL}/v1/me/reading-list/share`, {
    token,
    data: { ...data, resource: id },
  }).then((r) => r.read);
};

export const getProjectMembers = (token, organization, project) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/members`,
    {
      token,
    },
  ).then((r) => r.members);
};

export const joinProject = (token, project) => {
  return put(`${Constants.API_URL}/v1/me/join/project/${project}`, {
    token,
  }).then((r) => r.project);
};

export const sendProjectInvite = (token, organization, project, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}/members`,
    {
      token,
      data,
    },
  ).then((r) => r.invites);
};

export const getOrganizationMembers = (token, organization) => {
  return get(
    `${Constants.API_URL}/v1/me/organizations/${organization}/members`,
    {
      token,
    },
  ).then((r) => r.members);
};

export const fetchOrganization = (token, code) => {
  return get(`${Constants.API_URL}/v1/me/organizations/${code}`, {
    token,
  }).then((r) => r.organization);
};

export const fetchUsers = (token) => {
  return get(`${Constants.API_URL}/v1/me/users`, {
    token,
  }).then((r) => r.users);
};

export const fetchUser = (token, id) => {
  return get(`${Constants.API_URL}/v1/me/users/${id}`, {
    token,
  }).then((r) => r.user);
};

export const addUser = (token, data) => {
  return post(`${Constants.API_URL}/v1/me/users`, {
    token,
    data,
  }).then((r) => r.user);
};

export const updateUser = (token, id, data) => {
  return put(`${Constants.API_URL}/v1/me/users/${id}`, {
    token,
    data,
  }).then((r) => r.user);
};

export const fetchResource = (token, id) => {
  return get(`${Constants.API_URL}/v1/library/${id}`, {
    token,
  }).then((r) => r.resource);
};

export const updateResource = (token, id, data) => {
  return put(`${Constants.API_URL}/v1/library/${id}`, {
    token,
    data,
  }).then((r) => r.resource);
};

export const sendOrganizationInvite = (token, organization, data) => {
  return post(
    `${Constants.API_URL}/v1/me/organizations/${organization}/members`,
    {
      token,
      data,
    },
  ).then((r) => r.invites);
};

export const joinOrganization = (token, organization) => {
  return put(`${Constants.API_URL}/v1/me/join/organization/${organization}`, {
    token,
  }).then((r) => r.organization);
};

export const sendToken = (auth_token, token) => {
  return post(`${Constants.API_URL}/v1/me/tokens`, {
    token: auth_token,
    data: { token },
  }).then((responseJson) => {
    return responseJson.token;
  });
};

export const updateProfile = (token, data) => {
  return put(`${Constants.API_URL}/v1/me/`, {
    token,
    data,
  }).then((r) => r.user);
};

export const updatePassword = (token, data) => {
  return put(`${Constants.API_URL}/v1/me/password`, {
    token,
    data,
  }).then((r) => r.user);
};

export const updateOrganization = (token, organization, data) => {
  return put(`${Constants.API_URL}/v1/me/organizations/${organization}`, {
    token,
    data,
  }).then((r) => r.organization);
};

export const createOrganization = (token, data) => {
  return post(`${Constants.API_URL}/v1/me/organizations`, {
    token,
    data,
  }).then((r) => r.organization);
};

export const validateResource = (token, id) => {
  return put(`${Constants.API_URL}/v1/library/${id}/validate`, {
    token,
  }).then((r) => r.resource);
};

export const deleteResource = (token, id) => {
  return rdelete(`${Constants.API_URL}/v1/library/${id}`, {
    token,
  }).then((r) => r.resource);
};

export const deleteOrganization = (token, organization) => {
  return rdelete(`${Constants.API_URL}/v1/me/organizations/${organization}`, {
    token,
  }).then((r) => r.organization);
};

export const deleteProject = (token, organization, project) => {
  return rdelete(
    `${Constants.API_URL}/v1/me/organizations/${organization}/projects/${project}`,
    {
      token,
    },
  ).then((r) => r.project);
};

export const fetchStudyCases = (token) => {
  return get(`${Constants.API_URL}/v1/me/studycases`, {
    token,
  }).then((r) => r.result);
};

export const copyProjectAsStudyCase = (
  token,
  organizationCode,
  projectCode,
) => {
  return post(`${Constants.API_URL}/v1/me/studycases/copy`, {
    token,
    data: {
      organizationCode,
      projectCode,
    },
  }).then((r) => r.studycase);
};

export const fetchChats = (token) => {
  return get(`${Constants.API_URL}/v1/me/chats`, {
    token,
  }).then((r) => r.chats);
};

export const getChatDetails = (token, type, uuid) => {
  return get(`${Constants.API_URL}/v1/me/chats/${type}/${uuid}`, {
    token,
  }).then((r) => r.chat);
};

export const getChatMessages = (token, type, uuid) => {
  return get(`${Constants.API_URL}/v1/me/chats/${type}/${uuid}/messages`, {
    token,
  }).then((r) => r.messages);
};

export const getResourceOrganizations = (token) => {
  return get(`${Constants.API_URL}/v1/library/resources/publishers`, {
    token,
  }).then((r) => r.publishers);
};

export const getResourceAuthors = (token) => {
  return get(`${Constants.API_URL}/v1/library/resources/authors`, {
    token,
  }).then((r) => r.authors);
};

export const getExternalDictionary = (token) => {
  return get(`${Constants.API_URL}/v1/me/dictionary`, {
    token,
  }).then((r) => r.dictionary);
};

export const linkResourceToProject = (token, key, data) => {
  return post(`${Constants.API_URL}/v1/library/${key}/link`, {
    token,
    data,
  }).then((r) => r.link);
};

export const requestResetForgotInstructions = (email) => {
  return post(`${Constants.API_URL}/v1/forgot`, {
    data: { email },
  }).then((r) => r);
};

export const recoveryPassword = (token, password) => {
  return post(`${Constants.API_URL}/v1/recovery`, {
    token,
    data: { password },
  }).then((r) => r);
};



// WEBPACK FOOTER //
// ./src/api/index.js